import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-16 md:py-32 bg-gray-50 relative overflow-hidden pb-32 md:pb-32">
      {/* Sparkles */}
      <div className="sparkle-container">
        <div className="sparkle sparkle-left" style={{ background: 'rgba(130, 162, 132, 0.4)', left: '5%', top: '20%' }}></div>
        <div className="sparkle sparkle-left-2" style={{ background: 'rgba(130, 162, 132, 0.6)', left: '10%', top: '60%' }}></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-gray-900 mb-3 md:mb-4">
            Visit Us
          </h2>
          <p className="text-base md:text-lg text-gray-600 font-light leading-relaxed max-w-2xl mx-auto">
            We'd love to see you. Text us to book your appointment.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {/* Address */}
          <a
            href="https://maps.google.com/?q=Middleton+Loop+Albany+WA+6330"
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-white rounded-2xl p-8 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 text-center cursor-pointer"
          >
            <div className="w-20 h-20 bg-sage-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <MapPin className="w-10 h-10 text-sage-600" />
            </div>
            <h3 className="text-xl font-normal text-gray-900 mb-3">Address</h3>
            <p className="text-gray-600 font-light mb-2">Middleton Loop</p>
            <p className="text-gray-600 font-light mb-4">Albany, WA 6330</p>
            <span className="text-sage-600 font-normal text-sm">
              Get Directions →
            </span>
          </a>

          {/* Phone */}
          <a
            href="tel:0475409162"
            className="block bg-white rounded-2xl p-8 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 text-center cursor-pointer"
          >
            <div className="w-20 h-20 bg-sage-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Phone className="w-10 h-10 text-sage-600" />
            </div>
            <h3 className="text-xl font-normal text-gray-900 mb-3">Phone</h3>
            <p className="text-gray-600 font-light mb-2">0475 409 162</p>
            <p className="text-xs text-gray-500 font-light italic">
              We can't answer calls while with clients, so texting is preferred
            </p>
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/kove.thestudio"
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-white rounded-2xl p-8 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 text-center cursor-pointer"
          >
            <div className="w-20 h-20 bg-sage-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-10 h-10 text-sage-600" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </div>
            <h3 className="text-xl font-normal text-gray-900 mb-3">Instagram</h3>
            <span className="text-gray-600 font-light">
              @kove.thestudio
            </span>
          </a>
        </div>

        {/* CTA */}
        <div className="text-center mb-20 md:mb-0">
          <a
            href="sms:0475409162"
            className="inline-flex items-center justify-center bg-gray-900 text-white px-10 py-4 rounded-full hover:bg-gray-800 transition-all duration-300 font-normal tracking-wider text-sm shadow-lg"
          >
            BOOK YOUR APPOINTMENT
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;